/* Pure scroll maths for bringing today into view on load. No React, no DOM. */

/**
 * Where the window should scroll to centre today's strip, or null when the
 * whole strip is already on screen and the page should stay where it is.
 *
 * Positions are viewport pixels, as getBoundingClientRect reports them: `top`
 * and `bottom` are the strip's edges, and `coveredTop` is how far down the
 * window the sticky label bar reaches. A strip tucked under the bar is not on
 * screen, and the centre is taken in the room left beneath it rather than in
 * the whole window, or today would sit half a bar too high.
 */
export function todayScrollTarget({ top, bottom, coveredTop, viewportHeight, scrollY }) {
  if (top >= coveredTop && bottom <= viewportHeight) return null;
  const room = viewportHeight - coveredTop;
  const height = bottom - top;
  // Taller than the room (a wrapped strip on a landscape phone): show its top,
  // which is where the date is, rather than centring it off both edges.
  const inset = height < room ? (room - height) / 2 : 0;
  return Math.max(0, Math.round(scrollY + top - coveredTop - inset));
}
